import { render, staticRenderFns } from "./ConcernsSection.vue?vue&type=template&id=35419b66&"
import script from "./ConcernsSection.vue?vue&type=script&lang=js&"
export * from "./ConcernsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports